import React from "react";

const BackToMobile = () => {
  return <div>BackToMobile</div>;
};

export default BackToMobile;
